module.exports = {
  form_types: {
    classic: 1,
    external: 2,
    marketo: 3,
    eloqua: 4,
    hubspot: 5
  },
  inverted_form_types: {
    1: 'classic',
    2: 'external',
    3: 'marketo',
    4: 'eloqua',
    5: 'hubspot'
  }
}
